import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Button } from '@alfalab/core-components-button/esm';
import { transformSize } from './helpers/transformSize.js';

var defaultColors = {"primary":"icon-button__primary_iee2p","secondary":"icon-button__secondary_iee2p","transparent":"icon-button__transparent_iee2p","negative":"icon-button__negative_iee2p","tertiary":"icon-button__tertiary_iee2p","transparentBg":"icon-button__transparentBg_iee2p","component":"icon-button__component_iee2p","loader":"icon-button__loader_iee2p"};
require('./default.css')

var styles = {"border-24":"icon-button__border-24_vmk7h","border-32":"icon-button__border-32_vmk7h","border-40":"icon-button__border-40_vmk7h","border-48":"icon-button__border-48_vmk7h","border-56":"icon-button__border-56_vmk7h","size-24":"icon-button__size-24_vmk7h","size-32":"icon-button__size-32_vmk7h","size-40":"icon-button__size-40_vmk7h","size-48":"icon-button__size-48_vmk7h","size-56":"icon-button__size-56_vmk7h","iconWrapper":"icon-button__iconWrapper_vmk7h","center":"icon-button__center_vmk7h","left":"icon-button__left_vmk7h","right":"icon-button__right_vmk7h","icon":"icon-button__icon_vmk7h"};
require('./index.css')

var invertedColors = {"primary":"icon-button__primary_elhf3","secondary":"icon-button__secondary_elhf3","transparent":"icon-button__transparent_elhf3","negative":"icon-button__negative_elhf3","tertiary":"icon-button__tertiary_elhf3","transparentBg":"icon-button__transparentBg_elhf3","component":"icon-button__component_elhf3","loader":"icon-button__loader_elhf3"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SIZE_TO_CLASSNAME_MAP = {
    xxs: 'size-24',
    xs: 'size-32',
    s: 'size-48',
    24: 'size-24',
    32: 'size-32',
    40: 'size-40',
    48: 'size-48',
    56: 'size-56',
};
var IconButton = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, Icon = _a.icon, _c = _a.view, view = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 48 : _d, _e = _a.colors, colors = _e === void 0 ? 'default' : _e, _f = _a.alignIcon, alignIcon = _f === void 0 ? 'center' : _f, _g = _a.transparentBg, transparentBg = _g === void 0 ? false : _g, restProps = __rest(_a, ["className", "icon", "view", "size", "colors", "alignIcon", "transparentBg"]);
    return (React.createElement(Button, __assign({}, restProps, { ref: ref, view: 'text', className: cn('cc-icon-button', className, colorStyles[colors][view], colorStyles[colors].component, styles["border-".concat(transformSize(size))], (_b = {},
            _b[colorStyles[colors].loader] = restProps.loading,
            _b[colorStyles[colors].transparentBg] = transparentBg,
            _b)), size: 's' }),
        React.createElement("span", { className: cn(styles.iconWrapper, styles[SIZE_TO_CLASSNAME_MAP[size]], styles[alignIcon]) }, React.isValidElement(Icon) ? (React.cloneElement(Icon, { className: cn(styles.icon, Icon.props.className) })) : (React.createElement(Icon, { className: styles.icon })))));
});
IconButton.displayName = 'IconButton';

export { IconButton };
